import { createSelector } from 'reselect';

const customerSelector = state => state.customer;
const createCustomerSelector = createSelector(customerSelector, customerData => customerData);

export default createCustomerSelector;
